var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('woot-reports',{key:"label-reports",attrs:{"type":"label","getter-key":"labels/getLabels","action-key":"labels/get","download-button-label":_vm.$t('LABEL_REPORTS.DOWNLOAD_LABEL_REPORTS')}})}
var staticRenderFns = []

export { render, staticRenderFns }